import AutoComplete from './auto-complete';
import mapProps from '../scripts/utils/map-props';

export default mapProps([
  'value',
], {
  model: {
    prop: 'value',
    event: 'change',
  },
})(AutoComplete);
